<div class="card card-statistics mb-30">
  <div class="card-body">

    <h3 *ngIf="!InProccessing">لطفا صبر نمائید ...</h3>
    <div *ngIf="InProccessing">

      <form>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">نام مشتری </label>
            <input type="text" class="form-control" disabled value="{{inner_Record.customer_name}}" />
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">نوع تحویل به مشتری </label>
            <input type="text" class="form-control" disabled value="{{inner_Record.inperson}}" />
          </div>

        </div>

      </form>

      <div>

        <form [hidden]="MainRecord['inperson']!=1">
          <div class="row">

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> گیرنده </label>
              <input type="text" class="form-control" disabled value="{{MainRecord['inperson_type']}}" />
            </div>

            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> نام </label>
              <input type="text" class="form-control" disabled value="{{MainRecord['inpersonName']}}" />
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> شماره تماس </label>
              <input type="text" class="form-control" disabled value="{{MainRecord['inpersonPhone']}}" />
            </div>
            <div class="form-group col-md-3">
              <label for="exampleInputEmail1"> کدملی</label>
              <input type="text" class="form-control" disabled value="{{MainRecord['inpersonCodeMeli']}}" />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-md-12">
              <label for="exampleInputEmail1"> توضیحات تحویل به مشتری </label>
              <textarea class="form-control" disabled class="form-control"
              value="{{MainRecord['inpersonDsc']}}"></textarea>
            </div>
          </div>

        </form>

        <form [hidden]="MainRecord['inperson']!=0">
          <div class="row">
            <div class="form-group col-md-4">
              <label for="exampleInputEmail1"> کد رهگیری </label>
              <input type="text" class="form-control" disabled value="{{MainRecord['code_rahgiri']}}" />
            </div>

            <div class="form-group col-md-4">
              <label for="exampleInputEmail1"> تاریخ تحویل به پست</label>
              <input type="text" class="form-control" disabled value="{{MainRecord['tarikh_tahvil']}}" />
            </div>

            <div class="form-group col-md-4">
              <label for="exampleInputEmail1">کاشناس مسئول</label>
              <input type="text" class="form-control" disabled value="{{MainRecord['karshnas_masol_name']}}" />
            </div>
          </div>


        </form>

        <br />
        <br />



        <div class="table-responsive" *ngIf="Data_List_Calibration.length>0">
          <table class="mb-0 table table-bordered table-3 text-center table-striped">
            <thead style="background-color: #489b39; color: white;">
              <tr>
                <th>#</th>
                <th>نام دستگاه</th>
                <th>کد دستگاه</th>
                <th>سریال دستگاه</th>
                <th>توضیحات</th>
              </tr>
            </thead>
            <tbody>

              <ng-container *ngFor="let item of Data_List_Calibration">
                <tr>
                  <td>{{Data_List_Calibration.indexOf(item)+1}}</td>
                  <td class="EnglishClm">{{item.device_name}}</td>
                  <td>
                    <p class="EnglishClm">{{item.device_code}}</p>
                  </td>
                  <td>
                    <p class="EnglishClm">{{item.device_serial}}</p>
                  </td>
                  <td>
                    <p class="EnglishClm">{{item.dsc}}</p>
                  </td>
                </tr>


              </ng-container>



            </tbody>
          </table>
        </div>

      </div>

    </div>

  </div>
</div>
